export default "__VITE_ASSET__BmXNQ_GE__"